import { Checkbox } from "@mui/material";
import { palette } from "../theme/palette";
import { withStyles } from "@mui/styles";

const WhiteBackgroundCheckbox = withStyles((theme) => ({
  root: {
    color: palette.typography.white.high,
    "& .MuiIconButton-label": {
      position: "relative",
      zIndex: 0,
    },
    "&:not($checked) .MuiIconButton-label:after": {
      content: '""',
      left: 2,
      top: 2,
      height: 12,
      width: 12,
      position: "absolute",
      backgroundColor: palette.typography.white.high,
      zIndex: -1,
    },
  },
  checked: {},
}))(Checkbox);

export default WhiteBackgroundCheckbox;
